<app-feature-details-grid>
  <app-feature-list-container>
    <app-feature-list-item
      *ngIf="supplyTemperature$ | async | ready as feature"
      data-at-supply-temperature
      label="{{ '+INSTALLATIONS.INSTALLATION.CASCADES_LAG_DEVICE_OVERLAY.SUPPLY' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="burnerStatus$ | async | ready as feature"
      data-at-burner-status
      label="{{
        '+INSTALLATIONS.INSTALLATION.CASCADES_LAG_DEVICE_OVERLAY.BURNER_STATUS' | translate
      }}:"
      [value]="
        feature.properties?.active?.value
          | booleanSuffix
            : [
                customTranslationsService.STATE.on | translate,
                customTranslationsService.STATE.off | translate
              ]
      "
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="burnerModulation$ | async | ready as feature"
      data-at-burner-modulation
      label="{{
        '+INSTALLATIONS.INSTALLATION.CASCADES_LAG_DEVICE_OVERLAY.MODULATION' | translate
      }}:"
      value="{{ feature | value2: featurePropertyKey.value }}{{ feature | unit: 'value' }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>
